module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Posto_di_Blocco-BN-CL.28bc6cbb.svg";